<template>
    <div v-if="chartData.length != undefined && chartData.length > 1 && chartData.length != null">
        
        <div v-if="reportType == 'Mean/Median/Mode'">
            <GChart class="mb-15" type="ColumnChart" :data="chartData" :options="chartOptions"/>
            <div class="row">
                <div v-for="item in meanMedianModeData" :key="item.title" class="col-sm-6">
                    <div class="card box-shadow mb-15">
                        <div class="card-body">
                        <h5 class="card-title mb-0">
                            <i class="fp-truck-asset"></i> &nbsp;{{ item.title }} <span class="pull-right font-bold">{{ item.value }}</span>
                        </h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="reportType == 'Utilization Overview'">
            <GChart class="mb-15" type="ColumnChart" :data="chartData" :options="chartOptions"/>
            <div class="row">
                <div v-for="item in utilizationOverviewData" :key="item.title" class="col-sm-6">
                    <div class="card box-shadow mb-15">
                        <div class="card-body">
                        <h5 class="card-title mb-0">
                            <i class="fp-truck-asset"></i> &nbsp;{{ item.title }} <span class="pull-right font-bold">{{ item.value }}</span>
                        </h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div v-if="reportType == 'Utilization Detail'">
            <GChart class="mb-15" type="ColumnChart" :data="chartData" :options="chartOptions"/>
            <div class="row">
                <div v-for="item in utilizationDetailData" :key="item.title" class="col-sm-6">
                    <div class="card box-shadow mb-15">
                        <div class="card-body">
                        <h5 class="card-title mb-0">
                            <i class="fp-truck-asset"></i> &nbsp;{{ item.title }} <span class="pull-right font-bold">{{ item.value }}</span>
                        </h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="reportType == 'Active Units Detail'">
            <GChart class="mb-15" type="ColumnChart" :data="chartData" :options="chartOptions"/>
            <div class="row">
                <div v-for="item in activeUnitsDetailData" :key="item.title" class="col-sm-6">
                    <div class="card box-shadow mb-15">
                        <div class="card-body">
                        <h5 class="card-title mb-0">
                            <i class="fp-truck-asset"></i> &nbsp;{{ item.title }} <span class="pull-right font-bold">{{ item.value }}</span>
                        </h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div v-else>
        <span>No data Found</span>
    </div>
</template>


<script>
import Vue from "vue";
import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);
import { GChart } from 'vue-google-charts/legacy';
import {commonMixins} from '../../mixins/commonMixins';

export default ({
    components: {
        appFooter: () => import('@/components/Footer'),
        GChart
    },
    props: {
        fromModule: {
            type: Object,
            required: false,
            default: undefined
        },
    },
    computed: {
        meanMedianModeData() {
            return [
            {
                title: 'Active Units',
                value: this.activeUnits
            },
            {
                title: 'Mean Year',
                value: this.meanYear
            },
            {
                title: 'Median Year',
                value: this.medianYear
            },
            {
                title: 'Mode Year',
                value: this.modeYear
            }
            ];
        },
        utilizationOverviewData() {
            return [
            {
                title: 'Utilization (Average)',
                value: this.utilizationAvg + ' %'
            },
            {
                title: 'Group Non-Utilization (Average)',
                value: this.nonUtilizationAvg + ' %'
            }
            ];
        },
        utilizationDetailData() {
            return [
            {
                title: 'Utilized (Average)',
                value: this.utilizedAverage + ' %'
            },
            {
                title: 'Non-Utilized (Average)',
                value: this.nonUtilizedAverage + ' %'
            },
            {
                title: 'Utilized (Total)',
                value: this.utilizedTotal
            },
            {
                title: 'Non-Utilized (Total)',
                value: this.nonUtilizedTotal
            }
            ];
        },
        activeUnitsDetailData() {
            return [
            {
                title: 'Total Active Units',
                value: this.activeUnits
            },
            {
                title: 'Total Deactivated Units',
                value: this.deactivatedUnits
            },
            {
                title: 'Active Self-Managed',
                value: this.activeSelfManagedUnits
            },
            {
                title: 'Active SVT-Managed',
                value: this.activeSvtManagedUnits
            }
            ];
        }
    },
    watch:{
        
    },
    mixins:[commonMixins],
    data: () => ({
        activeUnits: 0,
        meanYear: 0,
        medianYear: 0,
        modeYear: 0,
        deactivatedUnits: 0,
        activeSelfManagedUnits: 0,
        activeSvtManagedUnits: 0,
        
        utilizationAvg: 0,
        nonUtilizationAvg: 0,
        
        utilizedAverage: 0,
        nonUtilizedAverage: 0,
        utilizedTotal: 0,
        nonUtilizedTotal: 0,
        
        chartData: [],
        chartOptions: {
            vAxis: { 
                format: '####', // year count without decimals
                viewWindow: {
                    min:0,
                },
            },
            hAxis: {
                format: '####', // year without decimals
            },
            chartArea: {
                left: 90, // Adjust the left spacing
                top: 50, // Adjust the top spacing
                width: '90%', // Adjust the width of the chart area
                height: '70%' // Adjust the height of the chart area
            },
            legend:'top',
            width: 900,
            height: 400,
            title: '',
            subtitle: '',
            colors: ['#F5CC90']
        },
        reportData:null,
        reportType:'',
    }),
    mounted: function() {
        let self = this;
        setTimeout(function () {
            self.getchartdata();
        }, 1000);
        
    },
    methods: {
        getchartdata(){
            let self = this;
            self.$parent.loading = true;
            
            if(self.fromModule!=null && self.fromModule!=undefined){
                self.reportData = self.fromModule;
                self.reportType = self.reportData.report_type.value;
            }

            let fields = {
                report_data:JSON.stringify(self.reportData),
            };

            $.ajax({
                url: process.env.ROOT_API + "/asset-reports/chart",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                crossDomain: true,
                success: function (data) {
                    if(data.content.chart_data != undefined){
                        self.chartData = data.content.chart_data;
                    }
                    if(data.content.counts != undefined){
                        self.handleCounts(data.content.counts);
                    }
                    self.$parent.loading = false;
                },
                error: function (jqXHR, exception) {
                    self.$parent.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'asset-reports');
                }
            });
        },
        handleCounts(counts){
            let self = this;
            if(self.reportType == 'Mean/Median/Mode'){
                self.activeUnits = counts.years_count;
                self.meanYear = counts.mean_year;
                self.medianYear = counts.median_year;
                self.modeYear = counts.mode_year;
            }
            if(self.reportType == 'Utilization Overview'){
                self.utilizationAvg = counts.utilization_avg;
                self.nonUtilizationAvg = counts.non_utilization_avg;
            }
            if(self.reportType == 'Utilization Detail'){
                self.utilizedAverage = counts.utilized_avg;
                self.nonUtilizedAverage = counts.non_utilized_avg;
                self.utilizedTotal = counts.utilized;
                self.nonUtilizedTotal = counts.non_utilized;
            }
            if(self.reportType == 'Active Units Detail'){
                self.activeUnits = counts.active_units;
                self.deactivatedUnits = counts.deactivated_units;
                self.activeSelfManagedUnits = counts.active_self_managed_units;
                self.activeSvtManagedUnits = counts.active_svt_managed_units;
            }
        },
    }
})
</script>



// WEBPACK FOOTER //
// src/components/dashboard/AssetChart.vue